export default __webpack_public_path__ + "static/media/spa-image-12.19f92d11.jpg";